import React from 'react'

import ProductTypeChip from '../../../components/ProductTypeChip'
import type { ExceptionConfig } from '../../exceptions/types'
import { fmtInt, fmtMoney } from './formatters'
import type { OverviewRow } from './types'

export const overviewConfig: ExceptionConfig = {
  codes: [],
  complexity: 'comparison',
  rowKeyField: 'product_type',
  defaultSortColumn: 'product_count',
  defaultSortDirection: 'desc',
  clientDefaultPageSize: 100,
  columns: [
    {
      key: 'product_type',
      label: 'Type',
      align: 'center',
      render: (_v, row) => (
        <ProductTypeChip
          productType={(row as OverviewRow).product_type}
          variant="long"
        />
      ),
    },
    {
      key: 'product_count',
      label: 'Products',
      align: 'right',
      render: (v) => fmtInt(v as number),
    },
    {
      key: 'sold_product_count',
      label: 'Sold in period',
      align: 'right',
      render: (_v, row) => {
        const r = row as OverviewRow
        const pct =
          r.product_count > 0
            ? Math.round((r.sold_product_count / r.product_count) * 100)
            : 0
        return `${fmtInt(r.sold_product_count)} (${pct}%)`
      },
    },
    {
      key: 'units_sold',
      label: 'Units sold',
      align: 'right',
      render: (v) => fmtInt(v as number),
    },
    {
      key: 'revenue',
      label: 'Revenue',
      align: 'right',
      render: (v) => fmtMoney(v as number),
    },
    {
      key: 'stock_product_count',
      label: 'Products with stock',
      align: 'right',
      render: (v) => fmtInt(v as number),
    },
    {
      key: 'units_on_hand',
      label: 'Units on hand',
      align: 'right',
      render: (v) => fmtInt(v as number),
    },
    {
      key: 'value_on_hand',
      label: 'On-hand value',
      align: 'right',
      render: (v) => fmtMoney(v as number),
    },
  ],
}
